import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import eth from './assets/eth.png'
import eth2x from './assets/eth@2x.png'
import Topic from '~shared/Topic'
import Display from '~shared/Display'
import urls from '~utils/urls'

const Text = styled.div`
    @media (min-width: ${TABLET}px) {
        ${Topic.Paragraph} {
            font-size: 1rem;
            line-height: 1.75rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Topic.Paragraph} {
            font-size: 1.125rem;
            line-height: 1.875rem;
        }
    }
`

const Icon = styled.div`
    img {
        max-width: 150px;
    }

    @media (min-width: ${DESKTOP}px) {
        img {
            max-width: 250px;
        }
    }
`

const Actions = styled.div`
    text-align: center;

    ${Button} {
        margin-top: 3rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Button} {
            margin-top: 3.5rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Button} {
            margin-top: 6rem;
        }
    }
`

const Inner = styled.div`
    margin: 0 auto;
    padding: 5.5rem 1.5rem 8rem;
    background-color: #FAFAFA;
    border-radius: 8px;
    color: #0C009A;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    ${Text} + ${Actions} {
        margin-top: 4.5rem;
    }

    ${Topic.Title} {
        margin: 0 0 2rem 0;
        text-align: left;
    }

    @media (min-width: ${TABLET}px) {
        max-width: 704px;
        padding: 7rem 5rem 5rem 6rem;
    }

    @media (min-width: ${DESKTOP}px) {
        max-width: 1160px;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 7rem 8rem 8.5rem 7.5rem;

        ${Text} + ${Actions} {
            margin-top: 0;
        }

        ${Text} {
            max-width: 514px;
        }
    }
`

const UnstyledHowDataUnionsWork = (props) => (
    <div {...props}>
        <Inner $appearDirection="none" $appearIntersection>
            <Text>
                <Display as={Topic.Title} mobile="none" tablet="block" hash="how-to-build" $appear>
                    How do Data Unions work?
                </Display>
                <Display as={Topic.Title} tablet="none" hash="how-to-build" $appear>
                    How do DUs work?
                </Display>
                <Topic.Paragraph $appear>
                    At a technical level, a Data Union product is an Ethereum smart
                    contract that receives subscription revenue via the Streamr
                    Marketplace and pays out provider rewards in $DATA. Streamr
                    Core app provides a graphical front end to simplify DU creation,
                    deployment and management.
                </Topic.Paragraph>
                <Topic.Paragraph $appear>
                    Typically an admin will build an application or integrate the
                    Data Union Framework into an existing application or service.
                    Using the Core app, new streams are created to carry the data,
                    then a new Data Union product is created and deployed.
                </Topic.Paragraph>
                <Topic.Paragraph $appear>
                    Users join the Data Union in a draft state, then it is published to
                    the Marketplace once sufficient users have joined. The admin
                    can monitor members and revenue via the DU tab in Core.
                </Topic.Paragraph>
            </Text>
            <Actions $appear>
                <Icon>
                    <img src={eth} srcSet={eth2x} alt="Intro to Data Unions docs" />
                </Icon>
                <Button
                    tag="a"
                    kind="primary"
                    size="big"
                    href={urls.docs.dataUnions}
                >
                    Intro to Data Unions docs
                </Button>
            </Actions>
        </Inner>
    </div>
)

const HowDataUnionsWork = styled(UnstyledHowDataUnionsWork)`
    padding: 0 1rem;

    @media (min-width: ${TABLET}px) {
        padding: 0 2rem;
    }

    @media (min-width: ${DESKTOP}px) {
        padding: 0;
    }
`

export default HowDataUnionsWork
